import { useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import CloseIcon from '@mui/icons-material/Close';
import { Tooltip } from '@mui/material';
import topicGroupEngine from './TopicGroupEngine';
import './YourNotesGroupManager.css';

const tooltipSx = {
    tooltip: { sx: { bgcolor: '#0b1e2e', color: '#b0c8e0', border: '0.5px solid #294766', fontSize: '11px', borderRadius: '3px' } },
    popper: { sx: { zIndex: 10000 } },
};

/**
 *  for settings visiblity of group aka hide group tabs in YourNotes
 *
 * @param {*} param0
 * @returns
 */
export default function YourNotesGroupManager({ open, onClose }) {
    const [pos, setPos] = useState({ top: 120, right: 40 });
    const dragging = useRef(false);
    const dragOffset = useRef({ x: 0, y: 0 });

    if (!open) return null;

    const groups = topicGroupEngine.getGroups();

    const handleToggle = async (group) => {
        const newStateId = group.stateId === 2 ? 0 : 2;
        const form = { ...group, stateId: newStateId };
        await topicGroupEngine.save(form);
    };

    const handleMouseDown = (e) => {
        dragging.current = true;
        dragOffset.current = {
            x: e.clientX + pos.right,
            y: e.clientY - pos.top,
        };

        const onMove = (e) => {
            if (!dragging.current) return;
            setPos({
                top: e.clientY - dragOffset.current.y,
                right: dragOffset.current.x - e.clientX,
            });
        };

        const onUp = () => {
            dragging.current = false;
            window.removeEventListener('mousemove', onMove);
            window.removeEventListener('mouseup', onUp);
        };

        window.addEventListener('mousemove', onMove);
        window.addEventListener('mouseup', onUp);
    };

    const panel = (
        <div className="yngm-panel" style={{ top: pos.top, right: pos.right }}>
            <div className="yngm-titlebar yngm-titlebar--draggable" onMouseDown={handleMouseDown}>
                <span>Group Manager</span>
                <div className="yngm-titlebar-actions">
                    <Tooltip title="Close" componentsProps={tooltipSx}>
                        <button className="yngm-titlebar-btn" onClick={onClose}>
                            <CloseIcon sx={{ fontSize: 15 }} />
                        </button>
                    </Tooltip>
                </div>
            </div>

            <div className="yngm-body">
                <div className="yngm-section-label">Groups</div>
                {groups.map((g) => (
                    <div key={g.rk} className="yngm-row">
                        <span className="yngm-group-name">{g.name}</span>
                        <label className="yngm-toggle">
                            <input type="checkbox" checked={g.stateId !== 2} onChange={() => handleToggle(g)} />
                            <span className="yngm-toggle-slider" />
                        </label>
                    </div>
                ))}
            </div>
        </div>
    );

    return createPortal(panel, document.body);
}
